import { createWebHistory, createRouter } from "vue-router";
import routes from './routes';
import appConfig from "../../app.config";

// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0, left: 0 };
  },
});

// Route guard to handle URL modification
router.beforeEach((to, from, next) => {
  // Define patterns for routes that need endpoint removal
  const endpointRoutes = ['/qr-customer-1', '/qr-customer-2', '/DoctorMaster/prescription', '/my-appointment'];

  // Check if the current path matches any endpoint route with a trailing number
  for (const route of endpointRoutes) {
    if (to.path.startsWith(route) && /\d+$/.test(to.path)) {
      // Remove the last segment (endpoint)
      const pathSegments = to.path.split('/');
      const removedSegment = pathSegments.pop(); // Remove the last segment

      // Save the removed segment to localStorage
      localStorage.setItem('removedPathSegment', removedSegment);

      // Redirect to the modified URL without the endpoint
      const modifiedPath = pathSegments.join('/');
      return next(modifiedPath);
    }
  }

  // Continue with the navigation if no modification is needed
  next();
});

// Optional: Additional router hooks
router.beforeResolve(async (to, from, next) => {
  try {
    for (const route of to.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(to, from, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error('Redirected'));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  
  document.title = to.meta.title + ' | ' + appConfig.title;
  next();
});

export default router;
